import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { ScriptStore } from './script.store';

declare var document: any;

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  loadGlobalPaymentsLibrary(url?: string): Promise<any> {
    return (window as any)?.GlobalPayments
      ? Promise.resolve((window as any).GlobalPayments)
      : new Promise((resolve) => {
          try {
            const script = document.createElement('script');
            script.defer = true;
            script.src = url ??= ScriptStore[0].src || '';
            script.onload = () => {
              resolve((window as any).GlobalPayments);
            };
            document.body.appendChild(script);
          } catch (e) {
            throwError;
          }
        });
  }
}
